function parseFormData(record) {
  try {
    return record.form_data ? JSON.parse(record.form_data) : {};
  } catch (e) {
    return {};
  }
}

export function resolveProvinceLabel(provinceId, addressMaps) {
  const id = provinceId != null ? String(provinceId).trim() : '';
  if (!id) {
    return '';
  }

  return addressMaps?.provinces?.[id] ?? id;
}

export function resolveWardLabel(provinceId, wardId, addressMaps) {
  const p = provinceId != null ? String(provinceId).trim() : '';
  const w = wardId != null ? String(wardId).trim() : '';
  if (!w) {
    return '';
  }
  if (w === '-1') {
    return addressMaps?.wards?.['-1'] ?? 'Khác';
  }

  const key = `${p}:${w}`;

  return addressMaps?.wards?.[key] ?? addressMaps?.wards?.[w] ?? w;
}

export function getSchoolCellValues(record, addressMaps) {
  const formData = parseFormData(record);
  const provinceId = formData.school_province ?? record.school_province ?? '';
  const wardId = formData.school_ward ?? record.school_ward ?? '';
  const schoolName = formData.school_name ?? record.school_name ?? '';

  return {
    province: resolveProvinceLabel(provinceId, addressMaps),
    ward: resolveWardLabel(provinceId, wardId, addressMaps),
    school: schoolName,
  };
}

export function getRegistrationCellValue(record, field, addressMaps) {
  const formData = parseFormData(record);

  if (field.type === 'school') {
    const { province, ward, school } = getSchoolCellValues(record, addressMaps);

    return [province, ward, school].filter(Boolean).join(' / ');
  }

  const name = field.name;
  const value = formData[name] ?? record[name];

  return value ?? '';
}

export function buildRegistrationTableColumns(fields = [], addressMaps = {}) {
  const cols = [
    { title: 'ID', dataIndex: 'id', width: 70, fixed: 'left' },
    {
      title: 'Thời gian đăng ký',
      dataIndex: 'created_at',
      width: 160,
    },
  ];

  fields.forEach((field, index) => {
    if (field.type === 'school') {
      const labels = field.labels || {};
      cols.push({
        title: labels.province || 'Tỉnh/TP',
        key: `school-province-${index}`,
        width: 140,
        render: (_, record) =>
          getSchoolCellValues(record, addressMaps).province,
      });
      cols.push({
        title: labels.ward || 'Phường/Xã',
        key: `school-ward-${index}`,
        width: 160,
        render: (_, record) => getSchoolCellValues(record, addressMaps).ward,
      });
      cols.push({
        title: labels.school || 'Trường THPT',
        key: `school-name-${index}`,
        width: 200,
        render: (_, record) => getSchoolCellValues(record, addressMaps).school,
      });
      return;
    }
    cols.push({
      title: field.label || field.name,
      key: `${field.name}-${index}`,
      render: (_, record) => getRegistrationCellValue(record, field, addressMaps),
    });
  });

  return cols;
}
